import { createAsyncThunk } from "@reduxjs/toolkit"
import apiRequest from "../../lib/http"
import { normalizeError } from "../../utils/errorHelpers"

export const getOwnDailyEmail = createAsyncThunk('accountingDailyCsv/getOwn', async (_, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get('/accounting-daily-csv/subscription')
    return response.data.data
  } catch (error) {
    return rejectWithValue(normalizeError(error))
  }
})

export const setOwnDailyEmail = createAsyncThunk('accountingDailyCsv/setOwn', async ({ enabled }, { rejectWithValue }) => {
  try {
    const response = await apiRequest.put('/accounting-daily-csv/subscription', { enabled })
    return response.data.data
  } catch (error) {
    return rejectWithValue(normalizeError(error))
  }
})

export const getUserDailyEmail = createAsyncThunk('accountingDailyCsv/getUser', async (userId, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get(`/accounting-daily-csv/subscription/users/${encodeURIComponent(userId)}`)
    return response.data.data
  } catch (error) {
    return rejectWithValue(normalizeError(error))
  }
})

export const setUserDailyEmail = createAsyncThunk('accountingDailyCsv/setUser', async ({ userId, enabled }, { rejectWithValue }) => {
  try {
    const response = await apiRequest.put(`/accounting-daily-csv/subscription/users/${encodeURIComponent(userId)}`, { enabled })
    return response.data.data
  } catch (error) {
    return rejectWithValue(normalizeError(error))
  }
})

export const downloadDailyFile = createAsyncThunk('accountingDailyCsv/downloadFile', async (fileId, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get(`/accounting-daily-csv/files/${encodeURIComponent(fileId)}`)
    return response.data.data
  } catch (error) {
    return rejectWithValue({
      message: normalizeError(error),
      status: error?.response?.status,
      routed: Array.isArray(error?.response?.data?.error?.errors),
    })
  }
})
